import Model from './Model'
import colorSchemeRepository from '../Images/ColorSchemeRepository'

export default class Wall extends Model
{
  constructor(width, height, data) {

    super(width, height, data);

    this.thickness = 50;
    this.opening = 158;

    this.canvas = null;
    this.ctx = null;

  }

  getOpening() {
    return this.opening * this.zoom;
  }

  getThickness() {
    return this.thickness * this.zoom;
  }

  clear(ctx, gameX, gameY, gameWidth, gameHeight) {

    ctx.clearRect(this.previousX - 2, this.previousY - 2, this.scale(this.width) + 4,this.scale(this.thickness) + 4);
    ctx.clearRect(this.previousX - 2, this.previousY - 2, this.scale(this.thickness) + 4,this.scale(this.height) + 4);
    ctx.clearRect(this.previousX + this.scale(this.width - this.thickness) - 2, this.previousY - 2, this.scale(this.thickness) + 4,this.scale(this.height) + 4);
    ctx.clearRect(this.previousX - 2, this.previousY + this.scale(this.height - this.thickness) - 2, this.scale(this.width) + 4,this.scale(this.thickness) + 4);

  }

  doPosition(ctx, gameX, gameY, gameWidth, gameHeight, force) {

    this.doDraw(ctx, gameX, gameY, gameWidth, gameHeight);

  }

  render() {}

  doDraw(ctx, gameX, gameY, gameWidth, gameHeight){

    gameX = gameX / this.zoom;
    gameY = gameY / this.zoom;

    this.previousY = this.scale(this.y - gameY);
    this.previousX = this.scale(this.x - gameX);

    ctx.beginPath();

    // top
    ctx.rect(this.scale(this.x - gameX), this.scale(this.y - gameY), this.scale(this.width), this.scale(this.thickness));

    // left
    ctx.rect(this.scale(this.x - gameX), this.scale(this.y + this.thickness - gameY), this.scale(this.thickness), this.scale(this.height - this.thickness * 2));

    // right
    ctx.rect(this.scale(this.x + this.width - this.thickness - gameX), this.scale(this.y + this.thickness - gameY), this.scale(this.thickness), this.scale(this.height - this.thickness * 2));

    // left bottom
    ctx.rect(this.scale(this.x - gameX), this.scale(this.y + this.height - this.thickness - gameY), this.scale(this.opening - this.thickness - this.x), this.scale(this.thickness));

    // right bottom
    ctx.rect(this.scale(this.x + this.opening - gameX + this.thickness - this.x), this.scale(this.y + this.height - this.thickness - gameY), this.scale(this.width - this.opening - this.thickness + this.x), this.scale(this.thickness));
    ctx.fillStyle = colorSchemeRepository.get('wallBackground');

    ctx.fill();

  }

}
